var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1879 4.5051L10.4371 1.39816C10.1216 0.838342 9.56065 0.558281 8.99967 0.558105C8.47357 0.557941 7.94746 0.803941 7.62373 1.29621L7.5622 1.39816L5.81054 4.5051C5.79445 4.53356 5.76966 4.55547 5.74023 4.56838L5.70947 4.57805L2.21318 5.28381C0.953432 5.53823 0.455637 7.07189 1.32549 8.01809L3.73897 10.6434L3.7583 10.6698C3.7691 10.6883 3.77551 10.709 3.77764 10.7304V10.762L3.36807 14.3058C3.22066 15.5825 4.52495 16.5299 5.69365 15.995L8.93682 14.5114L8.96758 14.5009C8.97817 14.4986 8.98893 14.4975 8.99967 14.4976C9.0208 14.4977 9.04189 14.5024 9.06158 14.5114L12.3048 15.995C13.437 16.5132 14.6974 15.6403 14.6409 14.4244L14.6312 14.3058L14.2216 10.762C14.2168 10.7188 14.2309 10.6754 14.2603 10.6434L16.6739 8.01809L16.7512 7.92756C17.5118 6.97706 17.006 5.53011 15.7853 5.28381L12.289 4.57805C12.2571 4.57155 12.2285 4.55524 12.2073 4.53147L12.1879 4.5051Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarMarketplace);
export default __webpack_public_path__ + "static/media/starMarketplace.c661322ef4bf9687809e51ed23093152.svg";
export { ForwardRef as ReactComponent };